import {ref} from 'vue';

let statistic = ref({});
let updating = false;
let timeOut;

function add(user_id) {
    let url = window.location.href;
    if (statistic.value[url] === undefined) {
        statistic.value[url] = [];
    }
    const index = statistic.value[url].indexOf(user_id);
    if (index === -1) {
        statistic.value[url].push(user_id);
        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
            updateImpressions();
        }, 5000);
    }


}

function updateImpressions() {
    if (Object.keys(statistic.value).length) {
        console.log('update impressions', statistic.value);
        // $api.app.setFeedback(statistic.value)
        statistic.value = {};
    } else {
        console.log('nothing to do!');
    }

}

function getStatistic() {
    return statistic.value;
}

export default {
    add, statistic
}
